module.exports = __webpack_public_path__ + "img/main-desk.6ab2755f.webp";